'use client'
import { FormField, FormInput } from '../../../FormElements'
import React, { ReactNode } from 'react'
import { FilterItem, FilterItemProps } from '../FilterItem'
import { useDefaultFilter } from '../hooks/useDefaultFilter'
import { FilterOperator } from '../../../../types'

export interface TextFilterProps extends Pick<FilterItemProps, 'width'> {
    /** "name" of object that should be filtered on. Will be used to create unique ID for "Filter" Object. This should be exactly the key that the API needs to filter on */
    name: string
    label?: string | ReactNode
    operator?: FilterOperator
}

export const TextFilter = ({
    label,
    operator = FilterOperator.EQUALS,
    name,
    width,
    ...props
}: TextFilterProps): JSX.Element => {
    const { fieldName, value, setValue } = useDefaultFilter(name, operator)

    return (
        <FilterItem width={width}>
            <FormField label={label} name={fieldName} className="w-full">
                <FormInput
                    {...props}
                    value={value ? String(value) : ''}
                    onChange={(value: string) => setValue(value)}
                    name={fieldName}
                />
            </FormField>
        </FilterItem>
    )
}
